import { Middleware } from 'redux';

import {
  getRetentionFunnelsDataFromStorage,
  setInitialDataToStorage,
} from 'hooks/useRetentionFunnels';
import { authSuccess } from 'store/auth/authSlice';
import { getUser } from 'store/auth/selectors';

export const refreshRetentionPopupsMiddleware: Middleware =
  (store) => (next) => (action) => {
    if (action.type === authSuccess.type) {
      const user = getUser(store.getState());
      const storageData = getRetentionFunnelsDataFromStorage();

      if (storageData && !user?.is_premium) {
        setInitialDataToStorage();
      }
    }

    return next(action);
  };
